export enum AssignmentStatus {
  Default = 'default',
  New = 'new',
  Warning = 'warning',
  Active = 'active',
}
